const constants = {
  MESSAGE_STATUS_CONTAINER: "MESSAGE_STATUS_CONTAINER",
  HEADING_CONTAINER: "HEADING_CONTAINER",
  MESSAGE_STATUS_HEADER: "MESSAGE_STATUS_HEADER",
  MESSAGE_STATUS_COPY: "MESSAGE_STATUS_COPY",
  VIEW_ISSUES_BY: "VIEW_ISSUES_BY",
  BUTTON_GROUP_1: "BUTTON_GROUP_1",
  BUTTON_GROUP_2: "BUTTON_GROUP_2",
  PHONE_NUMBERS_BTN: "PHONE_NUMBERS_BTN",
  SUB_ACCOUNTS_BTN: "SUB_ACCOUNTS_BTN",
  MESSAGE_ERRORS_BTN: "MESSAGE_ERRORS_BTN",
  SCORE_BTN: "SCORE_BTN",
  HELP_ME_BTN: "HELP_ME_BTN",
  prompts: {
    specificMessage: "I have a specific message to troubleshoot?",
    topErrorCodes:
      "Can you give me a list of top error codes from my messaging account?",
    topCountries:
      "Can you give me a list of top countries with message delivery errors?",
    topPhoneNumbers:
      "Can you give me a list of top phone numbers with message delivery errors?",
    topSubaccounts:
      "Can you give me a list of top sub accounts with message delivery errors?",
    helpMe: "How can you help me?",
    commonMessageErrors: "What are common message errors?",
    failedVsUndelivered: "What are undelivered vs. failed status?",
    DeliverabilityScore: "What is Deliverability Score?",
  },
};

export default constants;
